


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import BankModal from './BankModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { FaFilter } from "react-icons/fa";

const BankList = () => {
    const [banks, setBanks] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedBankId, setSelectedBankId] = useState(null);
    const [selectedBankData, setSelectedBankData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [errors, setErrors] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const firstLoad = useRef(true);
    const { roles, permissions } = useAuth();
    const [allBanks, setAllBanks] = useState([]);
    const [countries, setCountries] = useState([]);
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    const fetchBanks = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let params = { page };
            if (typeFilter) params.type = typeFilter;
            if (searchQuery) params.search = searchQuery;
            const response = await axios.get(`${backendUrl}/api/bank-accounts`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params,
            });

            const { data, current_page, last_page } = response.data.account;

            setBanks(data);

            setCurrentPage(current_page - 1);
            setPageCount(last_page);
        } catch (error) {
            console.error('Error fetching banks:', error);
        }
    };

    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,
            });

            let countryList = response.data.Data;

            // Ensure country with ID 231 (AED) appears first
            countryList = countryList.sort((a, b) => (a.id === 231 ? -1 : b.id === 231 ? 1 : 0));

            setCountries(countryList);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };


    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchBanks(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery, typeFilter]);



    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    //     const canEdit = permissions.includes('bank-edit');
    //   const canDelete = permissions.includes('bank-delete');
    const WithDeletePermission = withPermission(({ children }) => children, ['bankaccount-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['bankaccount-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['bankaccount-create']);



    const addBank = async (newBank) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/bank-accounts`, newBank, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const createdBank = response.data?.account;
            if (createdBank) {
                setBanks((prevBanks) => [...prevBanks, createdBank]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal(); // Close modal after adding
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error adding bank:', error);
            }
        }
    };


    const editBank = async (bankId, updatedData) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/bank-accounts/${bankId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const updatedBank = response.data?.account;

            if (updatedBank) {
                setBanks((prevBanks) =>
                    prevBanks.map((bank) =>
                        bank.id === updatedBank.id ? updatedBank : bank
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error updating bank:', error);
            }
        }
    };

    const deleteBank = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;

                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/bank-accounts/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setBanks(banks.filter(bank => bank.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The bank has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting bank:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete bank. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (bankId = null) => {

        if (bankId) {
            const bankToEdit = banks.find(bank => bank.id === bankId);
            if (bankToEdit) {
                setSelectedBankData(bankToEdit);
            }
        } else {
            setSelectedBankData(null);
        }
        setSelectedBankId(bankId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBankId(null);
        setSelectedBankData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchBanks(selectedPage);
    };
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'type') setTypeFilter(value);

        setFilterDropdown(null); // Close dropdown after selection
    };
      const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${backendUrl}/api/bank-accounts/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || ` Imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

            // Refresh the list after import
            setTimeout(() => window.location.reload(), 1000);

            // Clear the file input
            event.target.value = '';

        } catch (error) {
            console.error('Import error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            event.target.value = "";

        } finally {
        }
    };

    // Export Functions
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/bank-accounts/export`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob', // Important for file download
                }
            );

            // Create blob link and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `BankAccounts_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
        }
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Accounts</h4>

                            </div>
                        </div>
                    </div>

                    {/* Bank Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* <div className="d-flex justify-content-end mb-3"> */}
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control font-size-12"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                          <div className="d-flex align-items-center gap-2">
                                            {/* Export Button */}
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            {/* Import Button */}
                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importLeadsFile"
                                                onChange={handleImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importLeadsFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={() => handleShowModal()} // Updated line
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Add Bank"
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button>
                                        </WithCreatePermission>
                                        </div>
                                    </div>
                                    {/* Table */}
                                    <div>
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th  >Account Type  <div className="dropdown d-inline-block">
                                                        <FaFilter
                                                            className="ms-2 cursor-pointer filter-color"
                                                            onClick={() => setFilterDropdown(filterDropdown === 'type' ? null : 'type')}
                                                        />
                                                        {filterDropdown === 'type' && (
                                                            <ul className="dropdown-menu show">
                                                                <li>
                                                                    <button className="dropdown-item" onClick={() => handleFilterChange('type', '')}>
                                                                        All
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button className="dropdown-item" onClick={() => handleFilterChange('type', 'bank account')}>
                                                                        Bank Account
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button className="dropdown-item" onClick={() => handleFilterChange('type', 'cash account')}>
                                                                        Cash Account
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        )}
                                                    </div></th>

                                                    <th className="align-middle" >Name</th>

                                                    <th className="align-middle">Opening Balance</th>
                                                    <th className="align-middle">Currency</th>
                                                    {/* <th className="align-middle">Exchange Rate</th> */}

                                                    <th className="align-middle">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {banks.length > 0 ? (
                                                    banks.map((bank, index) => (
                                                        <tr key={bank.id}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`bankCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`bankCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>

                                                            <td ><Link to={`/bank-accounts/details/${bank.id}`} className="dropdown-item">
                                                                {bank.type}</Link></td>
                                                            <td ><Link to={`/bank-accounts/details/${bank.id}`} className="dropdown-item">
                                                                {bank.name} </Link></td>

                                                            <td>{bank.opening_balance}</td>
                                                            <td>{bank.base_currency?.currency}</td>
                                                            {/* <td>{bank.exchange_rate || 0}</td> */}

                                                            <td>
                                                                {/* Action buttons for Edit and Delete */}
                                                                <div className="dropdown">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14" >
                                                                        <li>
                                                                            <Link to={`/bank-accounts/details/${bank.id}`} className="dropdown-item">
                                                                                View Details
                                                                            </Link>
                                                                        </li>
                                                                        <li>
                                                                            {/* {canEdit && ( */}
                                                                            <WithEditPermission>

                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleShowModal(bank.id)}
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            </WithEditPermission>

                                                                            {/* )}  */}
                                                                        </li>
                                                                        <li>
                                                                            {/* <WithDeletePermission> */}

                                                                            {/* {canDelete && ( */}
                                                                            <WithDeletePermission>

                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => deleteBank(bank.id)}
                                                                                >
                                                                                    Delete
                                                                                </button>
                                                                            </WithDeletePermission>

                                                                            {/* )}  */}
                                                                        </li>

                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9">No banks found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {/* <div className="d-flex justify-content-between align-items-center mt-3">
                                            <span style={{fontSize:'12px',color:'#6e6e6e'}}>Showing 1 to 10 of {banks.length} entries</span> */}
                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <BankModal
                        key={selectedBankId || 'new'}
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        bankId={selectedBankId}
                        bankData={selectedBankData}
                        addBank={addBank}
                        editBank={editBank}
                        banks={banks}
                        errors={errors}
                        setErrors={setErrors}
                        countries={countries}
                        fetchCountries={fetchCountries}

                    />
                </div>
            </div>
        </div>
    );
};

export default BankList;
